import React from "react";

function Navbar(props) {
  return (
    <nav className="navbar">
      <span className="brand">Base Calculator</span>
      <a href="https://github.com/jayakarthik-jk" className="author">
        Jayakarthik.jk
      </a>
    </nav>
  );
}

export default Navbar;
